import { Box, HStack, Text, Tooltip } from '@chakra-ui/react';
import CopyrightSharpIcon from '@gamma/ui/icons/CopyrightSharpIcon';
import { SidebarContext, SidebarFooterItem } from '@gamma/ui/navigation';
import { URLS } from '@investigator/shared/constants';
import { i18n } from '@investigator/shared/localization';
import moment from 'moment';
import { useContext } from 'react';

export const CopyrightPrivacyPolicy = () => {
  const { isOpen } = useContext(SidebarContext);

  const { corelight, privacyPolicy: privacyPolicyLink } = i18n.navigation;

  return (
    <Tooltip shouldWrapChildren isDisabled={!isOpen}>
      <SidebarFooterItem
        icon={<CopyrightSharpIcon color="gray.400" />}
        href={URLS.CORELIGHT_PRIVACY_POLICY}
        target="_self"
      >
        <HStack spacing={1} fontSize="sm" divider={<Box border={0}>|</Box>}>
          <Text>
            {moment().format('YYYY')} {corelight}
          </Text>
          <Text as="span" color="text.link" data-testid="privacy-policy">
            {privacyPolicyLink}
          </Text>
        </HStack>
      </SidebarFooterItem>
    </Tooltip>
  );
};
